import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { PagedList } from "../model/domain/PagedList";
import { User } from "../model/domain/User";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpClient) {}

  RegisterUser(user: User) {
    return this.http.post(`${environment.apiUrls.users}/register/`, user);
  }

  UpdateUser(id: number, user: User) {
    return this.http.put(`${environment.apiUrls.users}/update/${id}`, user);
  }

  GetUser(id: number) {
    return this.http.get<User>(`${environment.apiUrls.users}/${id}`);
  }

  GetUsers(
    accountManagerId: number = null,
    isExternalUser: boolean = null,
    selectedGroupId: number = null,
    nomeUsuario: string = null,
    page: number = null,
    pageSize: number = null
  ) {
    let url = `${environment.apiUrls.users}/account-managers`;

    if (accountManagerId) {
      url += `/${accountManagerId}`;
    }

    const params: any = {};
    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    if (isExternalUser != null) {
      params.isExternalUser = isExternalUser;
    }

    if (selectedGroupId != null) {
      params.groupId = selectedGroupId;
    }

    if (nomeUsuario != null) {
      params.userName = nomeUsuario;
    }

    return this.http.get<PagedList<User>>(url, {
      params,
    });
  }

  ExportUsers(
    accountManagerId: number = null,
    isExternalUser: boolean = null
  ): Observable<Blob> {
    let url = `${environment.apiUrls.users}/export`;

    if (accountManagerId) {
      url += `/${accountManagerId}`;
    }

    const params: any = {};
    if (isExternalUser != null) {
      params.isExternalUser = isExternalUser;
    }

    return this.http.get(url, {
      params: params,
      responseType: "blob",
    });
  }

  getEmailsList(groupType: string = null) {
    const params: any = {};

    if (groupType && groupType != "") {
      params.groupType = groupType;
    }

    return this.http.get<string[]>(`${environment.apiUrls.users}/emails-list`, {
      params,
    });
  }

  sendBatchEmail(
    emails: string[],
    subject: string,
    text: string
  ): Observable<any> {
    return this.http.post(`${environment.apiUrls.users}/send-batch-emails`, {
      emails,
      subject,
      text,
    });
  }
}
